import { createAsyncThunk } from '@reduxjs/toolkit';
import { serializeError } from 'shared/utils/redux';
import { overallSurveyApi } from 'container/overallSurveyApi';
import { OverallSurvey } from 'model/OverallSurvey';
import { abortAndRefreshSignalByKey } from 'shared/utils/api/abortAndRefreshSignalByKey';

import { STORE_NAME } from './initialState';

const ABORT_CONTROLLER_KEY = `${STORE_NAME}/abortController`;

export const fetchOverallCombine = createAsyncThunk<
  OverallSurvey.Combine | void,
  { projectId: number; query: string }
>(
  `${STORE_NAME}/fetchOverallCombine`,
  ({ projectId, query }) => {
    const signal = abortAndRefreshSignalByKey(ABORT_CONTROLLER_KEY);
    return overallSurveyApi.combine({ projectId, query }, { signal });
  },
  { serializeError }
);

export const fetchOverallCompare = createAsyncThunk<
  OverallSurvey.Compare | void,
  { projectId: number; query: string }
>(
  `${STORE_NAME}/fetchOverallCompare`,
  ({ projectId, query }) => {
    const signal = abortAndRefreshSignalByKey(ABORT_CONTROLLER_KEY);
    return overallSurveyApi.compare({ projectId, query }, { signal });
  },
  { serializeError }
);
